import { render } from "./ConversationsCol.vue?vue&type=template&id=4aba18ba&scoped=true"
import script from "./ConversationsCol.vue?vue&type=script&lang=js"
export * from "./ConversationsCol.vue?vue&type=script&lang=js"

import "./ConversationsCol.vue?vue&type=style&index=0&id=4aba18ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aba18ba"]])

export default __exports__